import React from "react";
import AnalyticsContainer from "../../container/admin/analytics/analyticsContainer";
import AnalyticsProvider from "../../container/admin/analytics/context/analyticsContext";

const Analytics = (): React.JSX.Element => (
  <AnalyticsProvider>
    <AnalyticsContainer />
  </AnalyticsProvider>
);

export default Analytics;
